import { Button } from "@material-ui/core";
import { HintField, InputField, SelectField } from "components";
import { TextareaField } from "components/TextareaField";
import { FieldArray, FormikProvider, useFormik } from "formik";
import { SubHeader } from "layout/SubHeader";
import React, { createRef, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { DatePickerField } from "_metronic/_partials/controls";
import "./index.scss";

const AddParticipant = ({ form }) => {
  const exceptThisSymbols = ["e", "E", "+", "-"];

  const preventArrows = (e) => {
    if (e.which === 38 || e.which === 40 || exceptThisSymbols.includes(e.key))
      e.preventDefault();
  };
  const [localFormat, setLocalFormat] = useState(false);
  const registrationForm = (formFields, index) => {
    const formType = formFields.fldInputType;
    switch (formType) {
      case "text":
        return (
          <div className="params-values">
            <InputField
              rows="5"
              cols="35"
              mandatory={false}
              fldDisplay
              {...{
                formik,
                title: `${formFields.fldDisplay}`,
                name: `register.${index}.${formFields.fldDisplay}`,
              }}
            />
            {
              <HintField
                className="formik-error"
                error={
                  formik?.errors?.register &&
                  formik?.errors?.register[index]?.description
                }
              />
            }
          </div>
        );
      case "number":
        return (
          <div className="params-values">
            <InputField
              type="number"
              rows="5"
              cols="35"
              mandatory={false}
              fldDisplay
              {...{
                // labelFieldClass: "text-input-field",
                formik,
                title: `${formFields.fldDisplay}`,
                name: `register.${index}.${formFields.fldDisplay}`,
              }}
              onKeyDown={(e) => preventArrows(e)}
            />
            {
              <HintField
                className="formik-error"
                error={
                  formik?.errors?.register &&
                  formik?.errors?.register[index]?.description
                }
              />
            }
          </div>
        );
      case "select":
        return (
          <div className="params-values ">
            <div className="multi-input-value pt-0 mt-0">
              <SelectField
                mandatory={false}
                {...{
                  formik,
                  title: `${formFields?.fldDisplay}`,
                  name: `register.${index}.${formFields.fldDisplay}`,
                  items: formFields.fldValues,
                  value: "Select",
                  placeholder: "Select Relation",
                  checkValidation: true,
                }}
                onClick={(data) => {
                  formik.setFieldValue(
                    `register.${index}.${formFields.fldDisplay}`,
                    data
                  );
                }}
              />
            </div>
          </div>
        );
      case "date":
        return (
          <div className="params-values">
            <DatePickerField
              fldDisplay
              {...{
                formik,
                title: `${formFields.fldDisplay}`,
                name: `register.${index}.${formFields.fldDisplay}`,
              }}
              onChange={(e) => {
                formik.setFieldValue(
                  `register.${index}.${formFields.fldDisplay}`,
                  e.target.value
                );
                setLocalFormat(true);
              }}
              localFormat={localFormat}
            />
            {
              <HintField
                className="formik-error"
                error={
                  formik?.errors?.register &&
                  formik?.errors?.register[index]?.description
                }
              />
            }
          </div>
        );
      case "textarea":
        return (
          <div className="params-values">
            <TextareaField
              rows="5"
              cols="35"
              mandatory={false}
              {...{
                // labelFieldClass: "text-input-field",
                formik,
                title: `${formFields.fldDisplay}`,
                name: `register.${index}.${formFields.fldDisplay}`,
                placeholder: "Write your description here",
              }}
            />
            {formik?.errors?.register &&
              formik?.errors?.register[index].description &&
              formik?.touched?.register[index] &&
              formik?.touched?.register[index].description && (
                <HintField
                  className="formik-error"
                  error={
                    formik?.errors?.register &&
                    formik?.errors?.register[index].description
                  }
                />
              )}
          </div>
        );
      case "upload":
        const inputFile = createRef(null);

        return (
          <div className="row mb-5">
            <div className="col-sm-12">
              <label
                style={{
                  fontSize: 15,
                  fontWeight: "500",
                  marginBottom: 1,
                }}
              >
                {formFields?.fldDisplay}
              </label>
            </div>
            <div className="position-relative">
              <input
                type="file"
                id={index}
                ref={inputFile}
                // name={`register.${index}.${formFields.formFieldName}`}
                style={{ display: "none" }}
                onChange={(event, data) => {}}
              />
              <div className="file-upload-container">
                <Button variant="contained">UPLOAD</Button>
              </div>
            </div>
            <HintField
              error={formik.errors["profile_img"]}
              className="col-sm-12"
            />
          </div>
        );
      default:
        return "";
    }
  };
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: [0, 0, 0],
    validationSchema: "",
  });

  return (
    <>
      <div className="create form">
        {/* <SubHeader
          className="subheader py-20"
          {...{
            title: "Add New Participant",
          }}
        /> */}
      </div>
      <div className="registration-form-container">
        <div className="registration-form">
          <Card className="card card-custom p-10 w-100 mb-20 shadow p-3 mb-5 bg-white rounded">
            <div className="registration-form-content">
              <form className="form fv-plugins-bootstrap fv-plugins-framework">
                <FormikProvider value={formik}>
                  <FieldArray
                    name="register"
                    render={({ insert, remove, pop, push }) => (
                      <>
                        <div>
                          <Row>
                            {form.length &&
                              form.map((data, index) => (
                                <Col className={`col-sm-4`} key={index}>
                                  <div className="mb-20">
                                    {registrationForm(data, 0)}
                                  </div>
                                </Col>
                              ))}
                          </Row>
                        </div>
                      </>
                    )}
                  />
                </FormikProvider>
              </form>
            </div>
          </Card>
        </div>
      </div>
    </>
  );
};
export default AddParticipant;
